import React from 'react';
import PropTypes from 'prop-types';
import KpiTile, { KPI_TILE_VARIANTS } from '../../components/molecules/KpiTile';
import { METRIC_TONES } from '../constants';
import { metricShape } from '../propShapes';
import css from './MetricTiles.css';

const TONE_VARIANTS = {
    [METRIC_TONES.GOOD]: KPI_TILE_VARIANTS.POSITIVE,
    [METRIC_TONES.BAD]: KPI_TILE_VARIANTS.NEGATIVE,
    [METRIC_TONES.NEUTRAL]: KPI_TILE_VARIANTS.NEUTRAL,
};

const deltaDirection = delta => {
    if (delta.startsWith('-')) return 'down';
    if (delta.startsWith('+')) return 'up';
    return 'flat';
};

const MetricTiles = ({ metrics }) => (
    <div className={css.cards}>
        {metrics.map((metric, index) => (
            <KpiTile
                key={index}
                compact
                label={metric.label}
                value={metric.value}
                delta={{
                    text: metric.delta,
                    direction: deltaDirection(metric.delta),
                    variant: TONE_VARIANTS[metric.tone] ?? KPI_TILE_VARIANTS.NEUTRAL,
                }}
            />
        ))}
    </div>
);

MetricTiles.propTypes = {
    metrics: PropTypes.arrayOf(metricShape).isRequired,
};

export default MetricTiles;
